module.exports = __webpack_public_path__ + "static/media/AUTOMANI.3baf3e2c.TTF";